<template>
  <div
    class="cmp-catalog-tracks-sidewindow-labelcopy"
    style="cursor: copy"
    @click="onLabelCopyClick"
  >
    <div class="label-row ut-flex">
      <label class="label-title">{{$t('artist')}}</label>
      <span class="title-details txtov">{{
        selectedTrackDetails.track.artist
      }}</span>
    </div>
    <div class="label-row ut-flex">
      <label class="label-title">{{$t('title')}}</label>
      <span class="title-details txtov">{{
        selectedTrackDetails.track.title
      }}</span>
    </div>
    <div class="label-row ut-flex">
      <label class="label-title">{{$t('playtime')}}</label>
      <span class="title-details txtov">{{
        selectedTrackDetails.track.playtime
      }}</span>
    </div>
    <div class="label-row ut-flex">
      <label class="label-title">{{$t('explicit_lyrics')}}</label>
      <span class="title-details txtov">{{
        selectedTrackDetails.track.explicit_flag ? $t('yes') : $t('no')
      }}</span>
    </div>
    <div class="label-row ut-flex">
      <label class="label-title">{{$t('p')}}</label>
      <span class="title-details txtov">{{
        selectedTrackDetails.track.p_line
      }}</span>
    </div>
    <div class="label-row ut-flex">
      <label class="label-title">{{$t('country')}}</label>
      <span class="title-details txtov">{{
        selectedTrackDetails.track.country
      }}</span>
    </div>
    <!-- <div class="spacer"></div> -->

    <div
      class="label-row ut-flex"
      v-if="
        selectedTrackDetails &&
          selectedTrackDetails.composers &&
          selectedTrackDetails.composers.length > 0
      "
    >
      <label class="label-title">{{$t('composer')}}</label>
      <span class="title-details txtov">
        {{ selectedTrackDetails.composers[0].name }}
      </span>
    </div>
    <div
      class="label-row ut-flex"
      v-if="
        selectedTrackDetails &&
          selectedTrackDetails.writers &&
          selectedTrackDetails.writers.length > 0
      "
    >
      <label class="label-title">{{$t('writer')}}</label>
      <span class="title-details txtov">
        {{ selectedTrackDetails.writers[0].name }}
      </span>
    </div>
    <div
      class="label-row ut-flex"
      v-if="
        selectedTrackDetails &&
          selectedTrackDetails.publishers &&
          selectedTrackDetails.publishers.length > 0
      "
    >
      <label class="label-title">{{$t('publisher')}}</label>
      <span class="title-details txtov">
        {{ selectedTrackDetails.publishers[0].name }}
      </span>
    </div>

    <!-- <div class="spacer"></div> -->

    <div
      class="label-row ut-flex"
      v-if="
        selectedTrackDetails &&
          selectedTrackDetails.additionals &&
          selectedTrackDetails.additionals.length > 0
      "
    >
      <label class="label-title">{{$t('info')}}</label>
      <span class="title-details txtov">
        {{ selectedTrackDetails.additionals[0].name }}
      </span>
    </div>

    <!-- <div class="label-row ut-flex">
      <label class="label-title">info2</label>
      <span 
        class="title-details txtov" 
        v-if="selectedTrackDetails && selectedTrackDetails.additionals && selectedTrackDetails.additionals.length > 0 && selectedTrackDetails.additionals[1].name">
          {{ selectedTrackDetails.additionals[1].name }}
      </span>
    </div> -->
  </div>
</template>

<script>
import { copyToClipboard } from "../../../../dt-plugins/clipboard/clipboard";
export default {
  props: ["selectedTrackDetails", "copyText"],
  methods: {
    onLabelCopyClick() {
      copyToClipboard(this.copyText);
    }
  }
};
</script>

<style lang="scss">
.cmp-catalog-tracks-sidewindow-labelcopy {
  background-color: #fff;
  cursor: copy;
  .label-row {
    padding: 0 10px;
    height: 24px;

    .title-details {
      flex: 2;
    }
    .label-title {
      flex: 1;
      width: 100%;
      min-width: 100px;
      max-width: 100px;
      color: var(--text-5);
      padding-right: 5px;
      position: relative;

      &:after {
        content: ":";
        position: absolute;
        right: 8px;
      }
    }
  }

  // .spacer {
  //   height: 16px;
  // }
}
</style>
